import { render } from "./GetStarted.vue?vue&type=template&id=bbca8c90&scoped=true"
const script = {}

import "./GetStarted.vue?vue&type=style&index=0&id=bbca8c90&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbca8c90"]])

export default __exports__